<div class="loggedin_menu">
  @if (this.currentUser && this.currentUser.passengerId) {
    <ul>
      <li>
        <a
          routerLink="/{{this.translate.currentLang.split('-')[0]}}/{{this.mForm.id}}">{{'order_confirmation_book_new_ride' |
          translate |
        ucFirst}}</a>
        <span class="separator"></span>
        <a
          routerLink="/dashboard/{{this.translate.currentLang.split('-')[0]}}/{{this.mForm.id}}/invoices">{{'invoices' |
          translate |
        ucFirst}}</a>
        <span class="separator"></span>
        <a
          routerLink="/dashboard/{{this.translate.currentLang.split('-')[0]}}/{{this.mForm.id}}/history">{{'bookings' |
          translate |
        ucFirst}}</a>
        <span class="separator"></span>
        <a class="logout" (click)="confirmLogout()">{{'logout' |
          translate |
        ucFirst}} ({{this.currentUser.firstName}})</a>
      </li>
    </ul>
  }

  @if (!this.currentUser || !this.currentUser.passengerId) {
    <ul>
      <li>
        @if (!route.parent.snapshot) {
          <span>
            <a
            href="{{this.translate.currentLang.split('-')[0]}}/{{this.mForm.id}}/">{{'book_now' | translate | ucFirst}}</a>
            <span class="separator"></span>
          </span>
        }
        <a
        href="dashboard/{{this.translate.currentLang.split('-')[0]}}/{{this.mForm.id}}/login">{{'login' | translate | ucFirst}}</a>
      </li>
    </ul>
  }
</div>


<ngx-smart-modal #confirmLogoutModal identifier="confirmLogoutModal"
  customClass="payment-preauth-model nsm-dialog-animation-ttb"
  (onDismiss)="confirmLogoutModal.close()">
  <div [innerHTML]="'confirm_logout' | translate | ucFirst" class="text-container"></div>
  <div class="wb-container" style="padding-top:10px;">
    <button
      class="wb-button-small" (click)="confirmLogoutModal.close()">
      {{'close' | translate | ucFirst}}
    </button>
    <button
      class="wb-button-small"
      (click)="logout();">
      {{'logout' | translate | ucFirst}}
    </button>
  </div>
</ngx-smart-modal>
